import React from 'react';
import styles from './style.module.css';
import {getLetter , stringToColor} from '../../../utilities/StringReRenderer';

export default function TestimonialCardD3({ testimonial , CStyle}) {
  const { post_title,  rating, post_content, testimonial_link } = testimonial

  return (
    <div className={styles.testimonialCard}>
     
      <div className={styles.testimonialHeader}>
        
        
      
        <div className={styles.userInfo}>
         
       
          <div className={styles.rating}>
            {[...Array(parseInt(rating))].map((_, i) => (
              <span style={CStyle.starStyle} class="dashicons dashicons-star-filled"></span>
            ))}
            { parseInt(rating) < 5 &&  [...Array(5 - parseInt(rating))].map((_, i) => (
              <span style={CStyle.starStyle} class="dashicons dashicons-star-empty"></span>
            ))}
          
          </div>
        </div>
      

      </div>

      <div className={styles.testimonialContent}>
       
       <p style={CStyle.txtColor} dangerouslySetInnerHTML={{ __html: post_content }} />

      
     </div>
     <p className={styles.userName} style={CStyle.titleColor}>{testimonial_link ? <a style={CStyle.titleColor} href={testimonial_link}>{post_title}</a> : post_title}</p>
     
      
    </div>
  )
}
